import { MAGNETIZE_THRESHOLD_PIXELS } from './consts'

// Reusable function to magnetize a single position
export const calcMagnetizePosition = (
  deltaX: number,
  currentPosition: number,
  breakpoints: number[]
) => {
  const newPosition = currentPosition + deltaX

  const closestBreakpoint = breakpoints.find(
    breakpoint =>
      Math.abs(newPosition - breakpoint) <= MAGNETIZE_THRESHOLD_PIXELS
  )

  if (closestBreakpoint !== undefined) {
    return {
      deltaX: closestBreakpoint - currentPosition,
      isMagnetizing: true,
      magnetizePosition: closestBreakpoint
    }
  }

  return {
    deltaX,
    isMagnetizing: false
  }
}

// Function for dragging (both edges move together)
export const magnetizeDrag = (
  deltaX: number,
  currentItemInitialLeft: number,
  currentItemInitialRight: number,
  breakpoints: number[],
  doMagnetize: (
    deltaX: number,
    currentPosition: number,
    breakpoints: number[]
  ) => number
) => {
  // Try left edge first
  const leftMagnetizedDeltaX = doMagnetize(
    deltaX,
    currentItemInitialLeft,
    breakpoints
  )
  if (leftMagnetizedDeltaX !== deltaX) {
    return leftMagnetizedDeltaX
  }

  // Then try right edge
  const rightMagnetizedDeltaX = doMagnetize(
    deltaX,
    currentItemInitialRight,
    breakpoints
  )
  return rightMagnetizedDeltaX
}
